<template>
  <el-dialog
    title="选择登录方式"
    v-model="visible"
    width="15%"
    :before-close="handleClose">
    <div class="login-buttons">
      <!-- <el-row :gutter="20">
        <el-col :span="3"></el-col>
        <el-col :span="18"
          ><el-button
            class="wechat-btn"
            @click="handleWechatLogin">
            <svg t="1745403098041" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5877" width="18" height="18"><path d="M307.2 392.533333m-34.133333 0a2 2 0 1 0 68.266667 0 2 2 0 1 0-68.266667 0Z" fill="#73C337" p-id="5878"></path><path d="M571.733333 571.733333m-25.6 0a1.5 1.5 0 1 0 51.2 0 1.5 1.5 0 1 0-51.2 0Z" fill="#73C337" p-id="5879"></path><path d="M477.866667 392.533333m-34.133333 0a2 2 0 1 0 68.266667 0 2 2 0 1 0-68.266667 0Z" fill="#73C337" p-id="5880"></path><path d="M708.266667 571.733333m-25.6 0a1.5 1.5 0 1 0 51.2 0 1.5 1.5 0 1 0-51.2 0Z" fill="#73C337" p-id="5881"></path><path d="M512 0C228.693333 0 0 228.693333 0 512s228.693333 512 512 512 512-228.693333 512-512S795.306667 0 512 0zM406.186667 643.413333c-29.013333 0-52.906667-6.826667-81.92-11.946667l-81.92 40.96 23.893333-71.68c-59.733333-40.96-93.866667-95.573333-93.866667-160.426667C170.666667 327.68 276.48 238.933333 406.186667 238.933333c116.053333 0 216.746667 71.68 237.226667 167.253333-6.826667 0-15.36-1.706667-22.186667-1.706667-112.64 0-199.68 83.626667-199.68 187.733333 0 17.066667 3.413333 34.133333 6.826667 49.493333C421.546667 643.413333 413.013333 643.413333 406.186667 643.413333zM761.173333 737.28l17.066667 59.733333-64.853333-35.84c-23.893333 5.12-47.786667 11.946667-69.973333 11.946667-112.64 0-199.68-76.8-199.68-172.373333C443.733333 503.466667 532.48 426.666667 643.413333 426.666667c105.813333 0 199.68 76.8 199.68 172.373333C844.8 653.653333 808.96 701.44 761.173333 737.28z" fill="#73C337" p-id="5882"></path></svg>
          <span class="ml-2 text-sm">通过 WeChat 登录</span>
          </el-button></el-col>
        <el-col :span="3"></el-col>
      </el-row> -->
      <el-row :gutter="20">
        <el-col :span="3"></el-col>
        <el-col :span="18">
          <el-button
            type="default"
            class="github-btn"
            :disabled="userbutton.btnshow"
            @click="handleGithubLogin">
            <svg t="1745403273476" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6904" width="18" height="18"><path d="M512 85.333333C276.266667 85.333333 85.333333 276.266667 85.333333 512a426.410667 426.410667 0 0 0 291.754667 404.821333c21.333333 3.712 29.312-9.088 29.312-20.309333 0-10.112-0.554667-43.690667-0.554667-79.445333-107.178667 19.754667-134.912-26.112-143.445333-50.133334-4.821333-12.288-25.6-50.133333-43.733333-60.288-14.933333-7.978667-36.266667-27.733333-0.554667-28.245333 33.621333-0.554667 57.6 30.933333 65.621333 43.733333 38.4 64.512 99.754667 46.378667 124.245334 35.2 3.754667-27.733333 14.933333-46.378667 27.221333-57.045333-94.933333-10.666667-194.133333-47.488-194.133333-210.688 0-46.421333 16.512-84.778667 43.733333-114.688-4.266667-10.666667-19.2-54.4 4.266667-113.066667 0 0 35.712-11.178667 117.333333 43.776a395.946667 395.946667 0 0 1 106.666667-14.421333c36.266667 0 72.533333 4.778667 106.666666 14.378667 81.578667-55.466667 117.333333-43.690667 117.333334-43.690667 23.466667 58.666667 8.533333 102.4 4.266666 113.066667 27.178667 29.866667 43.733333 67.712 43.733334 114.645333 0 163.754667-99.712 200.021333-194.645334 210.688 15.445333 13.312 28.8 38.912 28.8 78.933333 0 57.045333-0.554667 102.912-0.554666 117.333334 0 11.178667 8.021333 24.490667 29.354666 20.224A427.349333 427.349333 0 0 0 938.666667 512c0-235.733333-190.933333-426.666667-426.666667-426.666667z" fill="#000000" p-id="6905"></path></svg>
            <span class="ml-2 text-sm">{{userbutton.buttonText}}</span>
          </el-button>
        </el-col>
        <el-col :span="3"></el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script lang="ts" setup>
import { useUIStore } from "@/stores/loginDialog";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import { reactive, onMounted } from "vue";


const uiStore = useUIStore();
const route = useRoute();

const { loginDialogVisible: visible } = storeToRefs(uiStore);

const handleClose = () => {
  uiStore.hideLoginDialog();
};

const userbutton = reactive({
    buttonText:'',
    btnshow: false
});

const logintip = reactive({
    githuboauth:'通过 GitHub 登录',
    redirect:'正在登录，等待跳转中...'
});

const handleGithubLogin = () => {
  // 生成随机state
  const state = Math.random().toString(36).substring(2, 15);
  // 保存当前路由
  localStorage.setItem("OAUTH_LOGIN_URL", route.fullPath);
  userbutton.buttonText = logintip.redirect
  userbutton.btnshow =  true;
  // 跳转到GitHub认证
  window.location.href = `https://github.com/login/oauth/authorize?client_id=Ov23liAALOrBXgY5llBh&state=${state}&allow_signup=true`;
  //window.location.href = `https://github.com/login/oauth/authorize?client_id=Ov23liXBmFFYDu5oV6xl&state=${state}&allow_signup=true`;
};

// const handleWechatLogin = () => {
//   // 微信登录逻辑
//   console.log("wechatlogin");
// };
onMounted(() => {
    userbutton.buttonText = logintip.githuboauth
});

</script>

<style scoped>
.login-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 0;
}
.el-button {
  width: 100%;
}
.text-sm {
    font-size: .875rem;
    line-height: 1.25rem;
}
.ml-2 {
    margin-left: .5rem;
}
::v-deep .el-button.is-disabled {
	color: #000;
	cursor: not-allowed;
}
</style>
